module.exports = __webpack_public_path__ + "static/media/P1050634.fb4e42b5.JPG";